"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _ExitToApp = _interopRequireDefault(require("@material-ui/icons/ExitToApp"));

var _styles = require("@material-ui/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _SidebarNav = _interopRequireDefault(require("./SidebarNav"));

var _SidebarProfile = _interopRequireDefault(require("./SidebarProfile"));

var _components = require("../../../components");

var _reactI18next = require("react-i18next");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    drawer: _defineProperty({
      width: 240
    }, theme.breakpoints.up('lg'), {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }),
    root: {
      backgroundColor: theme.palette.primary.main,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      padding: theme.spacing(2),
      color: theme.palette.primary.contrastText
    },
    divider: {
      margin: theme.spacing(2, 0)
    },
    nav: {
      marginBottom: theme.spacing(2),
      color: theme.palette.primary.contrastText
    },
    bottomRow: {
      margin: theme.spacing(1, 0)
    },
    languageSwitcher: {
      color: theme.palette.primary.contrastText,
      '& svg': {
        fill: theme.palette.primary.contrastText
      }
    },
    signoutButton: {
      color: theme.palette.primary.contrastText,
      borderColor: theme.palette.primary.contrastText,
      '&:focus': {
        borderColor: theme.palette.secondary.light
      }
    }
  };
});
var CustomLanguageInput = (0, _core.withStyles)(function (theme) {
  return {
    input: {
      backgroundColor: theme.palette.primary.main,
      border: '1px solid #ced4da',
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      '&:focus': {
        borderRadius: 4,
        borderColor: theme.palette.secondary.light
      }
    }
  };
})(_core.InputBase);

var SignOutButton = function SignOutButton(_ref) {
  var props = _extends({}, _ref);

  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Button, _extends({
    variant: "outlined",
    className: classes.signoutButton,
    startIcon: /*#__PURE__*/_react.default.createElement(_ExitToApp.default, null)
  }, props));
};

var Sidebar = function Sidebar(_ref2) {
  var open = _ref2.open,
      variant = _ref2.variant,
      onClose = _ref2.onClose,
      className = _ref2.className,
      navMenu = _ref2.navMenu,
      onSignOut = _ref2.onSignOut,
      profileProps = _ref2.profileProps,
      langProps = _ref2.langProps,
      rest = _objectWithoutProperties(_ref2, ["open", "variant", "onClose", "className", "navMenu", "onSignOut", "profileProps", "langProps"]);

  var _useTranslation = (0, _reactI18next.useTranslation)('common'),
      t = _useTranslation.t;

  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Drawer, {
    anchor: "left",
    classes: {
      paper: classes.drawer
    },
    onClose: onClose,
    open: open,
    variant: variant
  }, /*#__PURE__*/_react.default.createElement("div", _extends({}, rest, {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_SidebarProfile.default, profileProps), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement(_SidebarNav.default, {
    className: classes.nav
  }, navMenu), /*#__PURE__*/_react.default.createElement(_core.Divider, null), /*#__PURE__*/_react.default.createElement(_components.Flex, {
    justify: "between",
    alignItems: "stretch",
    className: classes.bottomRow
  }, /*#__PURE__*/_react.default.createElement(_components.LanguageSwitcher, _extends({}, langProps, {
    className: classes.languageSwitcher,
    input: /*#__PURE__*/_react.default.createElement(CustomLanguageInput, null)
  })), /*#__PURE__*/_react.default.createElement(SignOutButton, {
    onClick: onSignOut
  }, t('logout')))));
};

Sidebar.propTypes = {
  className: _propTypes.default.string,
  onClose: _propTypes.default.func,
  open: _propTypes.default.bool.isRequired,
  onSignOut: _propTypes.default.func.isRequired,
  variant: _propTypes.default.string.isRequired
};
var _default = Sidebar;
exports.default = _default;